import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Optional,
  Output,
  Self,
} from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { NgControl } from '@angular/forms';
import { SimpleField } from '../../abstracts/simple-field';

@Component({
  selector: 'fb-rating-stars',
  templateUrl: './rating-stars.component.html',
  styleUrls: ['./rating-stars.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RatingStarsComponent extends SimpleField<number> implements OnInit {
  stars: number[] = new Array(5).fill(0).map((value: number, index: number) => index + 1);

  @Input() hasCursorPointer: boolean = false;
  @Input() rating: number = 0;

  @Output() changedEvent: EventEmitter<number> = new EventEmitter();
  constructor(
    private domSanitizer: DomSanitizer,
    private matIconRegistry: MatIconRegistry,
    protected override changeDetectorRef: ChangeDetectorRef,
    @Optional()
    @Self()
    protected override ngControl: NgControl,
  ) {
    super(changeDetectorRef, ngControl);
    this.matIconRegistry.addSvgIcon(
      'hulf_star',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/rating_stars/halfactive.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'active_star',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/rating_stars/active.svg'),
    );
    this.matIconRegistry.addSvgIcon(
      'noactive_star',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/rating_stars/noactive.svg'),
    );
  }

  setRating(rating: number): void {
    if (this.disable || this.readonly) {
      return;
    }

    this.changedEvent.emit(rating);
  }

  ngOnInit(): void {
    this.stars.forEach((elem: number, index: number) => {
      if (this.rating > elem && this.rating < this.stars[index + 1]) {
        this.stars[index + 1] = this.rating;
      }
    });
  }
}
